import {
  getRuntimeConfig,
  getRuntimeConfigPageProps,
  type RuntimeConfigPageProps,
} from '@catawiki/next-config/runtime-config';

export type SellerRuntimeConfig = RuntimeConfigPageProps['runtimeConfig'];

export function getSellerRuntimeConfig(): SellerRuntimeConfig {
  // This is server side part
  if (typeof window === 'undefined') {
    return getRuntimeConfigPageProps().runtimeConfig;
  }

  // Below is the client side part
  if (document.readyState !== 'complete') {
    const nextDataRuntimeConfig = JSON.parse(
      document.getElementById('__NEXT_DATA__')?.textContent || '{}'
    ).props?.pageProps?.runtimeConfig;

    return (nextDataRuntimeConfig ?? getRuntimeConfig()) as SellerRuntimeConfig;
  }

  return getRuntimeConfig() as SellerRuntimeConfig;
}
